export const searchTableData = <T extends Object>(
  data: T[],
  searchText: string
) => {
  if (searchText === "") return data;
  const searchTextLowerCase = searchText.toLowerCase();
  const keys = (data.length ? Object.keys(data[0]) : []) as (keyof T)[];
  return data.filter((item) => {
    return keys.some((key) => {
      if (key !== "sKey" && item[key] && typeof item[key] === "string")
        return String(item[key]).toLowerCase().includes(searchTextLowerCase);
      else return false;
    });
  });
};

export const sortTableData = <T extends Object>(
  data: T[],
  sortBy: keyof T,
  asc: boolean
) => {
  if (sortBy === "") return data;

  return data.sort((a, b) => {
    if (a[sortBy] < b[sortBy]) return asc ? -1 : 1;
    if (a[sortBy] > b[sortBy]) return asc ? 1 : -1;
    return 0;
  });
};
